import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Eicherbusonrentpune() {


const cardData = {
keyword: "Eicher Bus on Rent in Pune",
headingDescription: "Ruturaj Enterprises provides Eicher Bus on Rent in Pune for comfortable and organized transportation for families, tourists, corporate teams, school groups, wedding parties and event organizers. Eicher buses can be arranged for local sightseeing, airport transfers, picnics, family functions and outstation journeys, with suitable options for different group sizes and travel requirements. Whether you are planning a short Pune city trip or a longer multi-day tour, an Eicher bus offers a convenient way to keep the complete group together throughout the journey.",
topPlaces: [
{
title: "Malshej Ghat",
description: "Malshej Ghat is a scenic destination known for mountain landscapes, waterfalls, viewpoints and refreshing monsoon surroundings. An Eicher bus from Pune is suitable for families, friends, school groups and corporate teams planning a comfortable group excursion."
},
{
title: "Panchgani",
description: "Panchgani attracts visitors with its hill-station climate, viewpoints, valleys and family-friendly attractions. Groups can hire an Eicher bus from Pune for a coordinated sightseeing trip with convenient space for passengers and luggage."
},
{
title: "Dapoli",
description: "Dapoli offers beaches, coastal scenery and peaceful holiday locations, making it suitable for family vacations and group tours. A spacious Eicher bus provides a practical transportation option for groups traveling from Pune with luggage."
},
{
title: "Shirdi",
description: "Shirdi is a major pilgrimage destination visited by families, devotees and organized tour groups. Eicher bus rental from Pune allows larger groups to travel together conveniently during one-day or multi-day religious journeys."
},
{
title: "Khandala",
description: "Khandala is a popular hill destination near Pune with scenic valleys, viewpoints and pleasant surroundings. An Eicher bus can make group transportation easier for picnics, weekend outings, school trips and corporate recreational programs."
},
{
title: "Ratnagiri",
description: "Ratnagiri offers Konkan beaches, historical attractions and coastal landscapes for longer group holidays. An Eicher outstation bus is useful for families and tourist groups planning a multi-day journey from Pune."
},
{
title: "Bhimashankar",
description: "Bhimashankar combines religious importance with the natural beauty of the Western Ghats. Eicher bus services are suitable for pilgrimage groups, families and nature enthusiasts traveling from Pune for a planned group visit."
},
{
title: "Saputara",
description: "Saputara is a scenic hill destination in Gujarat that attracts tourists, families and organized travel groups. An Eicher bus provides a convenient option for longer outstation tours where passengers need to remain together throughout the journey."
},
{
title: "Tuljapur",
description: "Tuljapur is well known for the revered Tulja Bhavani Temple and attracts devotees from different parts of Maharashtra. Groups traveling from Pune can use an Eicher bus for organized pilgrimage transportation with room for passengers and luggage."
},
{
title: "Kashid",
description: "Kashid is a popular coastal getaway known for its beach and relaxed surroundings, making it suitable for family trips and group vacations. Eicher bus rental offers convenient shared transportation for groups planning a Pune-to-coastal destination journey."
}
],
services: [
{
name: "Eicher Bus Rental Pune",
description: "Eicher bus rental in Pune provides a convenient group transportation option for local travel, sightseeing, events and outstation journeys. Ruturaj Enterprises can arrange suitable Eicher buses for families, tourists, schools, corporate teams and large groups."
},
{
name: "Eicher Bus Hire Pune",
description: "Eicher bus hire in Pune is suitable for groups that prefer traveling together in one dedicated vehicle. It can be arranged for family holidays, weddings, school excursions, corporate outings, picnics, airport transfers and tourist tours."
},
{
name: "Eicher Bus Booking Pune",
description: "Eicher bus booking in Pune can be planned according to passenger strength, destination, travel duration and purpose of the journey. Advance arrangements are particularly useful for weddings, school trips, corporate events and multi-day group tours."
},
{
name: "Eicher AC Bus on Rent Pune",
description: "Eicher AC buses on rent in Pune provide a comfortable transportation option for passengers traveling during warm weather or on longer routes. They are suitable for family trips, corporate programs, tourist tours, weddings and outstation journeys."
},
{
name: "Eicher Luxury Bus Rental Pune",
description: "Luxury Eicher bus rental in Pune is suitable for groups looking for an upgraded travel environment for special occasions and longer journeys. It can be used for premium family tours, corporate events, destination weddings and organized tourist programs."
},
{
name: "Eicher Tourist Bus Pune",
description: "Eicher tourist buses in Pune are useful for sightseeing tours, pilgrimage trips, family holidays and multi-destination travel. A dedicated tourist bus allows passengers to follow the same itinerary while traveling together between attractions."
},
{
name: "Eicher Bus for Outstation Pune",
description: "An Eicher bus for outstation travel from Pune is suitable for destinations across Maharashtra and neighboring states. It provides practical group transportation for hill stations, pilgrimage routes, beaches, heritage destinations and extended holiday tours."
},
{
name: "Eicher Bus for Wedding Pune",
description: "Eicher buses can be hired for wedding transportation in Pune to move guests between residences, hotels, ceremony venues and reception locations. Dedicated group transportation makes it easier for families to coordinate guest movement during different wedding functions."
},
{
name: "Eicher Bus for Corporate Events Pune",
description: "Corporate teams can use Eicher buses for conferences, seminars, employee outings, exhibitions, meetings and company celebrations. Group transportation can be organized between offices, hotels, airports and event venues according to the corporate itinerary."
},
{
name: "Eicher Bus for School Trips Pune",
description: "Eicher buses are suitable for school excursions involving students, teachers and accompanying staff. They can support educational tours, historical visits, museums, nature excursions, recreational programs and school picnics."
},
{
name: "Eicher Bus for Family Trip Pune",
description: "Families traveling in larger groups can hire an Eicher bus from Pune for holidays, pilgrimages, reunions and weekend vacations. Traveling together offers better coordination and provides a practical solution for passengers carrying luggage."
},
{
name: "Eicher Bus for Group Travel Pune",
description: "Eicher buses provide convenient transportation for friends, relatives, community groups and organized tour parties. A single dedicated bus keeps everyone together and reduces the coordination required when several smaller vehicles are used."
},
{
name: "Eicher Bus for Picnic Pune",
description: "An Eicher bus for picnics from Pune is useful for families, schools, colleges, offices and social groups planning day outings. Groups can travel together with food, bags and other picnic supplies while maintaining a common travel schedule."
},
{
name: "Eicher Bus for Airport Pickup Pune",
description: "Eicher bus services for airport pickup are useful for larger families, corporate teams and tourist groups arriving together at Pune Airport. The spacious group vehicle can simplify transfers between the airport, hotels, offices and other planned destinations."
},
{
name: "Eicher Bus Near Me Pune",
description: "Customers searching for an Eicher bus near them in Pune can choose a suitable group transportation solution based on passenger count, route and trip duration. The service can support local sightseeing, events, airport transfers, family travel and outstation journeys."
},
{
name: "Eicher Bus Rental Service Pune",
description: "The Eicher bus rental service in Pune supports transportation requirements for families, schools, companies, tourists and event organizers. Arrangements can be planned for short local travel, full-day programs, weekend tours and longer outstation trips."
},
{
name: "Eicher Bus Hire for Events Pune",
description: "Eicher bus hire for events in Pune can help transport attendees and guests for exhibitions, conferences, cultural programs, private functions and large gatherings. Dedicated buses make movement between venues, hotels, parking areas and other locations more organized."
},
{
name: "Eicher Bus for Marriage Pune",
description: "Marriage transportation becomes easier when guests travel together in a dedicated Eicher bus. It can be used for transfers between family homes, hotels, marriage halls, reception venues and other locations connected with the celebration."
},
{
name: "Eicher Outstation Bus Rental Pune",
description: "Eicher outstation bus rental from Pune is suitable for longer group journeys to tourist destinations, pilgrimage centers, beaches, hill stations and major cities. It works well for multi-day itineraries involving several sightseeing stops."
},
{
name: "Affordable Eicher Bus Rental Pune",
description: "Affordable Eicher bus rental in Pune provides a practical way for groups to arrange dedicated transportation while avoiding the need for multiple cars. Selecting an appropriate vehicle category and capacity helps match the travel arrangement with the group's requirements."
},
{
name: "Eicher AC Tourist Bus Pune",
description: "Eicher AC tourist buses in Pune are suitable for sightseeing and holiday tours where passenger comfort is important. Air-conditioned travel provides a convenient environment for families, tourist groups, corporate teams and organized tour parties."
},
{
name: "Eicher Luxury Bus Hire Pune",
description: "Luxury Eicher bus hire in Pune is suitable for premium group travel during weddings, corporate programs, special celebrations and destination tours. It allows larger groups to travel together in a comfortable environment throughout the journey."
}
],
tableData: [
["Eicher Bus Rental Pune", "Eicher Bus Hire Pune"],
["Eicher Bus Booking Pune", "Eicher AC Bus on Rent Pune"],
["Eicher Luxury Bus Rental Pune", "Eicher Tourist Bus Pune"],
["Eicher Bus for Outstation Pune", "Eicher Bus for Wedding Pune"],
["Eicher Bus for Corporate Events Pune", "Eicher Bus for School Trips Pune"],
["Eicher Bus for Family Trip Pune", "Eicher Bus for Group Travel Pune"],
["Eicher Bus for Picnic Pune", "Eicher Bus for Airport Pickup Pune"],
["Eicher Bus Near Me Pune", "Eicher Bus Rental Service Pune"],
["Eicher Bus Hire for Events Pune", "Eicher Bus for Marriage Pune"],
["Eicher Outstation Bus Rental Pune", "Affordable Eicher Bus Rental Pune"],
["Eicher AC Tourist Bus Pune", "Eicher Luxury Bus Hire Pune"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Eicher Bus Travel",
WhyChoosedescription: "Eicher buses provide a practical group transportation environment for both local and long-distance journeys. Families, tourists, employees and students can remain together throughout the trip instead of coordinating several separate vehicles."
},
{
WhyChooseheading: "Suitable for Multiple Trip Types",
WhyChoosedescription: "The service can be used for family vacations, weddings, school excursions, corporate events, picnics, airport transfers and sightseeing programs. This flexibility makes Eicher buses useful for both personal and organized group travel."
},
{
WhyChooseheading: "AC Travel Options",
WhyChoosedescription: "Groups seeking additional comfort can choose an AC Eicher bus for suitable journeys, particularly during warm weather and extended road travel. Air-conditioned transportation creates a more pleasant environment for passengers during longer trips."
},
{
WhyChooseheading: "Convenient for Large Groups",
WhyChoosedescription: "A dedicated Eicher bus allows larger groups to travel together while maintaining a common itinerary. This can make passenger coordination much easier during weddings, school programs, corporate outings and tourist tours."
},
{
WhyChooseheading: "Practical Outstation Solution",
WhyChoosedescription: "Long-distance group journeys often require reliable space for passengers and travel bags. Eicher bus rental from Pune offers a practical shared transportation arrangement for multi-day holidays, pilgrimages and destination tours."
},
{
WhyChooseheading: "Useful for Tourist Programs",
WhyChoosedescription: "Tour operators and groups can use Eicher tourist buses for itineraries covering several attractions and destinations. Traveling together makes it easier to maintain a common sightseeing schedule and coordinate stops."
},
{
WhyChooseheading: "Event-Friendly Transportation",
WhyChoosedescription: "Eicher buses can support guest and participant transportation for weddings, marriages, corporate functions, school events and private gatherings. A dedicated vehicle helps simplify movement between different locations associated with an event."
},
{
WhyChooseheading: "Flexible Pune-Based Service",
WhyChoosedescription: "Ruturaj Enterprises provides Eicher bus rental solutions for groups starting from Pune and traveling locally or to other destinations. The arrangement can be planned according to passenger requirements, route, occasion and journey duration."
}
]
};








const faqData = [
{
question: "Can I rent an Eicher bus in Pune?",
answer: "Eicher bus rental in Pune is suitable for group transportation, sightseeing tours, school excursions, weddings, corporate programs, events, and outstation journeys. Ruturaj Enterprises can help arrange an appropriate bus according to passenger count, luggage, route, trip duration, and comfort requirements."
},
{
question: "Why choose an Eicher bus for group travel in Pune?",
answer: "An Eicher bus can be a practical option when a group needs dedicated transportation for a planned journey. Keeping passengers together in one vehicle makes it easier to coordinate pickup points, luggage, travel breaks, sightseeing schedules, and the return journey."
},
{
question: "Can I hire an Eicher bus from Pune for an outstation trip?",
answer: "An Eicher bus can be hired for group journeys from Pune to destinations such as Mumbai, Nashik, Kolhapur, Mahabaleshwar, Lonavala, Shirdi, Goa, and other locations. The rental arrangement can be planned according to the route, number of passengers, luggage, and trip duration."
},
{
question: "Can an Eicher bus be used for local sightseeing in Pune?",
answer: "Local Eicher bus rental can be useful for organized sightseeing, school and college trips, family outings, corporate activities, and group events around Pune. The itinerary can be planned around selected attractions, pickup locations, sightseeing time, and the group's preferred schedule."
},
{
question: "Is an Eicher bus suitable for school and college trips?",
answer: "Educational institutions and student groups can hire an Eicher bus for picnics, educational tours, excursions, industrial visits, and outstation programs. Having one dedicated vehicle helps teachers and organizers coordinate student travel, planned stops, and group movement more efficiently."
},
{
question: "Can families rent an Eicher bus in Pune for a tour?",
answer: "Families traveling with relatives can choose an Eicher bus when they need dedicated group transportation for a holiday or pilgrimage. Everyone can remain together during the journey while carrying luggage and coordinating meal breaks, sightseeing stops, and departure timings."
},
{
question: "Can corporate groups book an Eicher bus on rent in Pune?",
answer: "Corporate organizations can arrange Eicher buses for employee outings, conferences, company events, team-building activities, training programs, and group transportation. A dedicated bus helps employees travel together and keeps the movement between planned locations organized."
},
{
question: "Can I hire an AC Eicher bus in Pune?",
answer: "Groups that prefer an air-conditioned travel environment can inquire about an AC Eicher bus according to availability. Ruturaj Enterprises can help select a suitable vehicle by considering the group size, route, luggage, travel duration, and comfort preferences."
},
{
question: "What seating capacity should I choose for an Eicher bus rental?",
answer: "The appropriate Eicher bus capacity depends on the total number of passengers, luggage requirements, and the nature of the trip. Ruturaj Enterprises can help identify a suitable option for smaller or larger groups while considering journey duration and passenger comfort."
},
{
question: "Why choose Ruturaj Enterprises for Eicher bus rental in Pune?",
answer: "Ruturaj Enterprises provides group transportation solutions for local and outstation travel from Pune. An Eicher bus can be selected according to passenger capacity, route, luggage, trip duration, and travel purpose, making it suitable for tours, school trips, corporate programs, weddings, events, and family journeys."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Dinesh Pawar",
feedback:
"We hired an Eicher bus from Ruturaj Enterprises for an outstation family tour from Pune. Having everyone travel in one vehicle made the trip much easier to coordinate, especially with luggage and planned stops. The overall transportation arrangement was convenient for our group.",
rating: 5
},
{
id: 2,
name: "Miss. Radhika More",
feedback:
"Our group needed a bus for a sightseeing and picnic trip from Pune, so we chose an Eicher bus through Ruturaj Enterprises. The vehicle was a practical option for our group, and traveling together made the day's schedule easier to manage. We had a pleasant overall experience.",
rating: 5
}
];














































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Eicher Bus on Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/eicher-bus-on-rent-in-pune.webp",
  "description":
    "Eicher Bus on Rent in Pune for comfortable local travel, outstation journeys, family tours, group trips, weddings, corporate events, school outings, picnics and sightseeing. Ruturaj Enterprises provides Eicher bus rental options including AC, luxury and tourist buses with spacious seating, comfortable interiors, experienced drivers and flexible rental plans for one-day as well as long-distance travel from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/eicher-bus-on-rent-in-pune"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Eicher Bus on Rent in Pune | Eicher Bus Rental Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Eicher Bus on Rent in Pune for outstation trips, local travel, family tours, group journeys, weddings, corporate events, school trips and sightseeing. Hire Eicher AC, luxury and tourist buses from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="Eicher Bus Rental Pune, Eicher Bus Hire Pune, Eicher Bus Booking Pune, Eicher AC Bus on Rent Pune, Eicher Luxury Bus Rental Pune, Eicher Tourist Bus Pune, Eicher Bus for Outstation Pune, Eicher Bus for Wedding Pune, Eicher Bus for Corporate Events Pune, Eicher Bus on Rent Pune, Eicher AC Bus Rental Pune, Eicher AC Bus Hire Pune, Eicher Luxury Bus Hire Pune, Eicher Tourist Bus Rental Pune, Eicher Tourist Bus Hire Pune, Eicher Bus Rental Service Pune, Eicher Bus Hire Service Pune, Eicher Bus Booking Service Pune, Eicher Bus for Local Travel Pune, Eicher Bus for Family Trip Pune, Eicher Bus for Group Travel Pune, Eicher Bus for School Trips Pune, Eicher Bus for Picnic Pune, Eicher Bus for Sightseeing Pune, Eicher Bus for Pune Darshan, Eicher Bus for Airport Pickup Pune, Eicher Bus for Airport Drop Pune, Eicher Outstation Bus Rental Pune, Eicher Local Bus Rental Pune, Eicher Group Tour Bus Pune, Eicher Family Tour Bus Pune, Eicher Corporate Bus Rental Pune, Eicher Wedding Bus Rental Pune, Eicher Marriage Bus Hire Pune, Eicher School Tour Bus Pune, Eicher One Day Tour Bus Pune, Eicher Multi Day Tour Bus Pune, Eicher Religious Tour Bus Pune, Eicher Temple Tour Bus Pune, Eicher Maharashtra Tour Bus Pune, Eicher Goa Trip Bus Pune, Eicher Mumbai Trip Bus Pune, Eicher Lonavala Trip Bus Pune, Eicher Mahabaleshwar Trip Bus Pune, Eicher Nashik Trip Bus Pune, Eicher Shirdi Trip Bus Pune, Eicher Kolhapur Trip Bus Pune, Eicher Konkan Trip Bus Pune, Eicher Bus Rental Near Me Pune, Eicher Bus Hire Near Me Pune, Affordable Eicher Bus Rental Pune, Comfortable Eicher Bus Pune, Premium Eicher Bus Rental Pune, Eicher Bus for Group Tour Pune, Eicher Bus for Family Tour Pune, Ruturaj Enterprises Eicher Bus Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Eicherbusonrentpune ;